import { render, staticRenderFns } from "./add-project-modal.vue?vue&type=template&id=25fb2490&scoped=true"
import script from "./add-project-modal.vue?vue&type=script&lang=js"
export * from "./add-project-modal.vue?vue&type=script&lang=js"
import style0 from "./add-project-modal.vue?vue&type=style&index=0&id=25fb2490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb2490",
  null
  
)

export default component.exports